import { render, staticRenderFns } from "./AddTerm.vue?vue&type=template&id=1b5aebd2&"
import script from "./AddTerm.vue?vue&type=script&lang=js&"
export * from "./AddTerm.vue?vue&type=script&lang=js&"
import style0 from "./AddTerm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports